import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70657c1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-unstyled components"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "nav-header" }, "附属明細表（病院会計準則）", -1))
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-export nav-icon" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出力", -1))
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#fuzoku-meisai-junsoku",
  "data-toggle": "collapse",
  "aria-expanded": "false",
  class: "nav-link dropdown-toggle"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-wrench nav-icon" }),
  /*#__PURE__*/_createElementVNode("span", null, "設定")
], -1))
const _hoisted_8 = {
  class: "collapse list-unstyled menu-3",
  id: "fuzoku-meisai-junsoku"
}
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.shouldSetDate)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/fuzoku/junsoku/export",
            class: "nav-link"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: "/fuzoku/junsoku/junshisan",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("純資産明細表")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/fuzoku/junsoku/koteishisan",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("固定資産明細表")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/fuzoku/junsoku/kashitsukekin",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("貸付金明細表")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: "/fuzoku/junsoku/kariirekin",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("借入金明細表")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createVNode(_component_router_link, {
                to: "/fuzoku/junsoku/hikiatekin",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("引当金明細表")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createVNode(_component_router_link, {
                to: "/fuzoku/junsoku/hojokin",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("補助金明細表")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: "/fuzoku/junsoku/tanpo",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("担保権明細表")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createVNode(_component_router_link, {
                to: "/fuzoku/junsoku/kyuyo",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("給与費明細表")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_17, [
              _createVNode(_component_router_link, {
                to: "/fuzoku/junsoku/honbu",
                class: "nav-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("本部費明細表")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}